<template>
  <div>
    <v-dialog
      v-model="dialog"
      content-class="v-dialog--custom"
      :width="step == 1 ? '500px' : '80%'"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-form ref="form1" v-model="valid1" @submit.prevent="submitStep1()">
        <v-card v-show="step == 1">
          <v-card-title>
            {{ formTitle }}
            <v-spacer />
            <small>Page {{ step }} of 2</small>
          </v-card-title>
          <v-card-subtitle>
            {{ formSubtitle }}
          </v-card-subtitle>
          <v-card-text>
            <div>
              Did you take a 20 min break?
              <div>
                <v-radio-group
                  v-model="form1.q1"
                  column
                  @blur="$v.form1.q1.$touch()"
                >
                  <v-radio label="Yes" value="yes"></v-radio>
                  <v-radio label="No" value="no"></v-radio>
                </v-radio-group>

                <br />
                <v-textarea
                  v-show="form1.q1 == 'no'"
                  label="Please explain"
                  rows="3"
                  v-model="form1.explain1"
                  @blur="$v.form1.explain1.$touch()"
                ></v-textarea>
              </div>
            </div>

            <div>
              Did you take a 30 min lunch break?
              <div>
                <v-radio-group
                  v-model="form1.q2"
                  column
                  @blur="$v.form1.q2.$touch()"
                >
                  <v-radio label="Yes" value="yes"></v-radio>
                  <v-radio label="No" value="no"></v-radio>
                </v-radio-group>

                <br />
                <v-textarea
                  v-show="form1.q2 == 'no'"
                  label="Please explain"
                  rows="3"
                  v-model="form1.explain2"
                  @blur="$v.form1.explain2.$touch()"
                ></v-textarea>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="$v.form1.$invalid"
              type="submit"
              color="info"
              :loading="loading"
            >
              Next
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>

      <v-form v-model="valid2" @submit.prevent="submitStep2()">
        <v-card v-show="step == 2">
          <v-card-title>
            {{ formTitle }}
            <v-spacer />
            <small>Page {{ step }} of 2</small>
          </v-card-title>
          <v-card-text>
            <v-sheet elevation="6">
              <v-alert type="info">
                Total Manual Time should match Total Work Time
              </v-alert>
              <v-tabs
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows
                v-model="tabs"
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab
                  v-for="(changeOrder, changeOrderIdx) in changeOrderReversed"
                  :key="`${changeOrderIdx}_changeOrders_tab`"
                  :href="'#tab-' + changeOrderIdx"
                >
                  {{ changeOrder.title }}
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tabs">
                <v-tab-item
                  v-for="(changeOrder, changeOrderIdx) in changeOrderReversed"
                  :key="`${changeOrderIdx}_changeOrders_content`"
                  :value="'tab-' + changeOrderIdx"
                >
                  <v-card>
                    <v-card-title>
                      {{ changeOrder.titleTab }}
                    </v-card-title>
                    <v-card-text>
                      <v-card
                        class="mt-2"
                        v-for="(material, materialIdx) in changeOrder.materials"
                        :key="`${changeOrderIdx}_${materialIdx}_materials`"
                      >
                        <v-card-text>
                          <v-row>
                            <v-col
                              cols="12"
                              xl="4"
                              lg="6"
                              md="4"
                              sm="12"
                            >
                              <v-text-field
                                label="Material"
                                v-model="material.materialName"
                                :hide-details="true"
                                readonly
                              >
                              </v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              xl="1"
                              lg="2"
                              md="3"
                              sm="6"
                            >
                              <v-text-field
                                v-model.number="material.quantity"
                                label="Amount of Footage"
                                type="number"
                                :min="0"
                                :error-messages="
                                  [].concat(
                                    fieldErrors(
                                      [
                                        `changeOrderReversed`,
                                        `.$each[${changeOrderIdx}]`,
                                        `.materials`,
                                        `.$each[${materialIdx}]`,
                                        `.quantity`
                                      ].join(''),
                                      [
                                        `changeOrderReversed`,
                                        `.$each`,
                                        `.materials`,
                                        `.$each`,
                                        `.quantity`
                                      ].join(''),
                                    )
                                  )
                                "
                                :hide-details="
                                  [].concat(
                                    fieldErrors(
                                      [
                                        `changeOrderReversed`,
                                        `.$each[${changeOrderIdx}]`,
                                        `.materials`,
                                        `.$each[${materialIdx}]`,
                                        `.quantity`
                                      ].join(''),
                                      [
                                        `changeOrderReversed`,
                                        `.$each`,
                                        `.materials`,
                                        `.$each`,
                                        `.quantity`
                                      ].join(''),
                                    )
                                  ).length == 0
                                "
                                @blur="
                                  $v
                                  .changeOrderReversed
                                  .$each[changeOrderIdx]
                                  .materials
                                  .$each[materialIdx]
                                  .quantity
                                  .$touch()
                                "
                              >
                              </v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              xl="1"
                              lg="2"
                              md="2"
                              sm="6"
                            >
                              <v-text-field
                                v-model="material.unit"
                                label="Footage Unit"
                                readonly
                                :hide-details="true"
                                :error-messages="
                                  [].concat(
                                    fieldErrors(
                                      [
                                        `changeOrderReversed`,
                                        `.$each[${changeOrderIdx}]`,
                                        `.materials`,
                                        `.$each[${materialIdx}]`,
                                        `.unit`
                                      ].join(''),
                                      [
                                        `changeOrderReversed`,
                                        `.$each`,
                                        `.materials`,
                                        `.$each`,
                                        `.unit`
                                      ].join(''),
                                    )
                                  )
                                "
                                @blur="
                                  $v
                                  .changeOrderReversed
                                  .$each[changeOrderIdx]
                                  .materials
                                  .$each[materialIdx]
                                  .unit
                                  .$touch()
                                "
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              xl="1"
                              lg="2"
                              md="3"
                              sm="6"
                            >
                              <v-text-field
                                label="Amount of Material"
                                v-model.number="material.quantityPerCase"
                                type="number"
                                :min="0"
                                :error-messages="
                                  [].concat(
                                    fieldErrors(
                                      [
                                        `changeOrderReversed`,
                                        `.$each[${changeOrderIdx}]`,
                                        `.materials`,
                                        `.$each[${materialIdx}]`,
                                        `.quantityPerCase`
                                      ].join(''),
                                      [
                                        `changeOrderReversed`,
                                        `.$each`,
                                        `.materials`,
                                        `.$each`,
                                        `.quantityPerCase`
                                      ].join(''),
                                    )
                                  )
                                "
                                :hide-details="
                                  [].concat(
                                    fieldErrors(
                                      [
                                        `changeOrderReversed`,
                                        `.$each[${changeOrderIdx}]`,
                                        `.materials`,
                                        `.$each[${materialIdx}]`,
                                        `.quantityPerCase`
                                      ].join(''),
                                      [
                                        `changeOrderReversed`,
                                        `.$each`,
                                        `.materials`,
                                        `.$each`,
                                        `.quantityPerCase`
                                      ].join(''),
                                    )
                                  ).length == 0
                                "
                                @blur="
                                  $v
                                  .changeOrderReversed
                                  .$each[changeOrderIdx]
                                  .materials
                                  .$each[materialIdx]
                                  .quantityPerCase
                                  .$touch()
                                "
                              >
                              </v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              xl="1"
                              lg="3"
                              md="3"
                              sm="6"
                            >
                              <v-text-field
                                v-model="material.case"
                                :items="caseList"
                                label="Material Unit"
                                readonly
                                :hide-details="true"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              xl="2"
                              lg="3"
                              md="4"
                              sm="6"
                              v-if="material.case === 'Custom'"
                            >
                              <v-text-field
                                v-model="material.caseCustom"
                                label="Custom Material Unit"
                                readonly
                                :hide-details="true"
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              xl="1"
                              lg="2"
                              md="2"
                              sm="3"
                            >
                              <v-text-field
                                v-model.number="material.hours"
                                label="Man Hours"
                                type="number"
                                :min="0"
                                :error-messages="
                                  [].concat(
                                    fieldErrors(
                                      [
                                        `changeOrderReversed`,
                                        `.$each[${changeOrderIdx}]`,
                                        `.materials`,
                                        `.$each[${materialIdx}]`,
                                        `.hours`
                                      ].join(''),
                                      [
                                        `changeOrderReversed`,
                                        `.$each`,
                                        `.materials`,
                                        `.$each`,
                                        `.hours`
                                      ].join(''),
                                    )
                                  )
                                "
                                :hide-details="
                                  [].concat(
                                    fieldErrors(
                                      [
                                        `changeOrderReversed`,
                                        `.$each[${changeOrderIdx}]`,
                                        `.materials`,
                                        `.$each[${materialIdx}]`,
                                        `.hours`
                                      ].join(''),
                                      [
                                        `changeOrderReversed`,
                                        `.$each`,
                                        `.materials`,
                                        `.$each`,
                                        `.hours`
                                      ].join(''),
                                    )
                                  ).length == 0
                                "
                                @blur="
                                  $v
                                  .changeOrderReversed
                                  .$each[changeOrderIdx]
                                  .materials
                                  .$each[materialIdx]
                                  .hours
                                  .$touch()
                                "
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              xl="1"
                              lg="2"
                              md="2"
                              sm="3"
                            >
                              <v-text-field
                                v-model.number="material.minutes"
                                label="Minutes"
                                type="number"
                                :min="0"
                                :max="59"
                                :error-messages="
                                  [].concat(
                                    fieldErrors(
                                      [
                                        `changeOrderReversed`,
                                        `.$each[${changeOrderIdx}]`,
                                        `.materials`,
                                        `.$each[${materialIdx}]`,
                                        `.minutes`
                                      ].join(''),
                                      [
                                        `changeOrderReversed`,
                                        `.$each`,
                                        `.materials`,
                                        `.$each`,
                                        `.minutes`
                                      ].join(''),
                                    )
                                  )
                                "
                                :hide-details="
                                  [].concat(
                                    fieldErrors(
                                      [
                                        `changeOrderReversed`,
                                        `.$each[${changeOrderIdx}]`,
                                        `.materials`,
                                        `.$each[${materialIdx}]`,
                                        `.minutes`
                                      ].join(''),
                                      [
                                        `changeOrderReversed`,
                                        `.$each`,
                                        `.materials`,
                                        `.$each`,
                                        `.minutes`
                                      ].join(''),
                                    )
                                  ).length == 0
                                "
                                @blur="
                                  $v
                                  .changeOrderReversed
                                  .$each[changeOrderIdx]
                                  .materials
                                  .$each[materialIdx]
                                  .minutes
                                  .$touch()
                                "
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
              <table width="100%">
                <tr>
                  <td class="text-right">
                    <div class="pr-3">
                      Total Time Clock:
                      <v-chip small
                        >{{ totalTimeClock | formatTimeRoundupSecond }}
                      </v-chip>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="text-right">
                    <div class="pr-3">
                      Total Out Time:
                      <v-chip small
                        >{{ totalOutTime | formatTimeRoundupSecond }}
                      </v-chip>
                    </div>
                  </td>
                </tr>

                <tr><td class="py-2">&nbsp;</td></tr>

                <tr>
                  <td class="text-right">
                    <div class="pr-3">
                      Total Work Time:
                      <v-chip small
                        >{{ totalWorkTime | formatTimeRoundupSecond }}
                      </v-chip>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="text-right">
                    <div class="pr-3">
                      Total Manual Time:
                      <v-chip :color="matchColor" small
                        >{{ totalManualTime | formatTimeRoundupSecond }}
                      </v-chip>
                    </div>
                  </td>
                </tr>

                <tr v-if="matchColor === 'error'">
                  <td class="text-right" style="color: red">
                    <div class="pr-3">
                      Total Manual Time does not match Total Work Time
                    </div>
                  </td>
                </tr>

                
              </table>

              <v-col>

              <v-textarea v-model="form1.notes" :rows="3" label="Notes"/>
              </v-col>
            </v-sheet>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="darken-1" @click="step = 1">Previous</v-btn>

            <v-btn
              :disabled="$v.changeOrderReversed.$invalid || matchColor === 'error'"
              type="submit"
              color="info"
              :loading="loading"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import UTIL from "src/helpers/utility";
import { roundupSeconds, roundSecondsQuarterHour } from "src/utils/helpers";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "@/mixins/formatterMixin";

const defaultInputs = {
  id: "",
  clientId: "",
  name: "",
  description: "",
  rate: 0,
  type: "",
};

const defaultForm1 = {
  q1: "",
  q2: "",
  explain1: "",
  explain2: "",
  notes: ""
};

export default {
  components: {},
  props: {
    clientId: Number,
    task: Object,
    show: [Boolean, String],
    timeClockEntry: Object
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form1: {
      q1: { required },
      q2: { required },
      explain1: {
        required: requiredIf(function () {
          return this.form1.q1 === "no";
        }),
      },
      explain2: {
        required: requiredIf(function () {
          return this.form1.q2 === "no";
        }),
      },
    },
    changeOrderReversed: {
      $each: {
        materials: {
          $each: {
            taskId: {},
            changeOrderId: {},
            materialName: {},
            quantity: {
              minValue: minValue(0),
            },
            quantityPerCase: {
              minValue: minValue(0),
            },
            case: {},
            caseCustom: {},
            unit: {},
            hours: {
              minValue: minValue(0),
            },
            minutes: {
              minValue: minValue(0),
            },
          },
        },
      },
    },
  },
  validationMessages: {
    form1: {
      q1: { required: "Required" },
      q2: { required: "Required" },
      explain1: { required: "Required" },
      explain2: { required: "Required" },
    },

    changeOrderReversed: {
      $each: {
        materials: {
          $each: {
            taskId: {},
            changeOrderId: {},
            materialName: {},
            quantity: {
              minValue: "Must be 0 or greater"
            },
            quantityPerCase: {
              minValue: "Must be 0 or greater"
            },
            case: {},
            caseCustom: {},
            unit: {},
            hours: {
              minValue: "Must be 0 or greater"
            },
            minutes: {
              minValue: "Must be 0 or greater"
            },
          },
        },
      },
    },
  },

  data() {
    return {
      showDialog: this.show,

      stopTimeTemporary: null,

      form: {
        ...defaultInputs,
      },
      dialog: false,
      loading: false,

      step: 1,
      valid1: false,
      valid2: false,
      form1: {
        ...defaultForm1,
      },
      changeOrders: [],
      tabs: "",
      caseList: ["Case", "Custom", "Gallon", "Roll", "Sausage", "Tube"],
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    task(n, o) {
      if (n && JSON.stringify(n) !== JSON.stringify(o)) {
        this.form = {
          ..._.pick(n, _.keys(defaultInputs)),
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      timeclock: (state) => state.timeclock,
      alert: (state) => state.alert,
      status: (state) => state.questionnaire.status,
    }),
    formTitle() {
      return this.isEdit ? `End Time Clock #${this.task.code}` : "End Time Clock";
    },
    formSubtitle() {
      const employeeFirstName = this.timeClockEntry?.employeeFirstName;
      const employeeLastName = this.timeClockEntry?.employeeLastName;

      if (employeeFirstName || employeeLastName) {
        return `${employeeFirstName} ${employeeLastName}`
      } else {
        return ""
      }
    },
    isEdit() {
      return UTIL.gv(this.timeClockEntry, "id", "") ? true : false;
    },
    timeclockId() {
      return UTIL.gv(this.timeClockEntry, "id", "");
    },
    changeOrderReversed() {
      return [...this.changeOrders];
    },

    matchColor() {
      if (this.totalManualTime === this.totalWorkTime) {
        return "success";
      } else {
        return "error";
      }
    },

    totalOutTime() {
      let totalOutTime = 0;
      if(this.form1.q2 === "yes") {
        totalOutTime += 30 * 60; // 30 mins
      }
      return totalOutTime;
    },

    totalTimeClock() {
      let newStopTime = this.localToUtc(this.stopTimeTemporary);
      const totalTimeClock = this.sumTimeClockEntries([{
        ...this.timeClockEntry,
        stopTime: newStopTime
      }]);
      const roundedTotalTimeClock = roundSecondsQuarterHour(roundupSeconds(totalTimeClock));
      return roundedTotalTimeClock;
    },

    totalWorkTime() {
      return this.totalTimeClock - this.totalOutTime;
    },

    totalManualTime() {
      let totalManualTime = 0;
      this.changeOrderReversed.map((co) => {
        co.materials.map((mt) => {
          let hour = mt.hours ? mt.hours : 0;
          let minute = mt.minutes ? mt.minutes : 0;
          totalManualTime += parseFloat(hour * 3600) + parseFloat(minute * 60);
        });
      });
      return totalManualTime;
    },

    
  },

  methods: {
    ...mapActions("timeclock", ["create", "update"]),
    ...mapActions({
      submitQuestionanire: "questionnaire/create",
    }),

    initForm() {
      if (this.clientId) {
        this.form = {
          ...defaultInputs,
          clientId: this.clientId,
        };
      }

      this.form1 = {
        ...defaultForm1,
      };

      let jobMaterials = this.task.jobMaterials || [];
      // parse changeOrder here
      let changeOrders = [
        ...new Set(jobMaterials.map((obj) => obj.changeOrderId)),
      ];

      this.changeOrders = changeOrders.map((changeOrderIdx) => {
        let materials = jobMaterials
          .filter((m) => m.changeOrderId == changeOrderIdx)
          .map((material) => {
            const caseFinal = !this.caseList.includes(material.case)
              ? "Custom"
              : material.case;
            const caseFinalCustom = caseFinal === "Custom" ? material.case : "";

            return {
              ...material,
              case: caseFinal,
              caseCustom: caseFinalCustom,
              quantity: null,
              quantityPerCase: null,
              hours: null,
              minutes: null,
            };
          });

        return {
          id: changeOrderIdx,
          title: changeOrderIdx == 1 ? "Original" : `CO #${changeOrderIdx - 1}`,
          titleTab:
            changeOrderIdx == 1
              ? "Original Quote"
              : `Change Order #${changeOrderIdx - 1}`,
          materials,
        };
      });

      // sort by change order id, to keep original quote and additional quote tab position
      this.changeOrders.sort(function (a, b) {
        return a.id - b.id;
      });
    },

    serverSideErrors(field) {
      return UTIL.gv(this.timeclock.errors, field, []);
    },
    onDialogClose() {
      this.step = 1;
      this.loading = false;
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });
      this.stopTimeTemporary = new Date();
      this.initForm();
    },

    completed() {
      this.$emit("onSucceded");
    },

    async submitStep1() {
      this.loading = false;
      this.step = 2;
    },

    async submitStep2() {
      let jobMaterialsUsed = [];

      this.changeOrderReversed.map((changeOrders) => {
        changeOrders.materials.map((material) => {
          delete material.id;
          let totalHoursInSeconds = parseInt(material?.hours || 0) * 3600;
          let totalMinutesInSeconds = parseInt(material?.minutes  || 0) * 60;

          let caseFinal = material.case == "Custom"
            ? material.caseCustom
            : material.case;
          let payloadMaterial = {
            ...material,
            case: caseFinal,
            quantity: material?.quantity || 0,
            quantityPerCase: material?.quantityPerCase || 0,
            seconds: totalHoursInSeconds + totalMinutesInSeconds,
          };
          delete payloadMaterial.hours;
          delete payloadMaterial.minutes;
          jobMaterialsUsed.push(payloadMaterial);
        });
      });
      let payload = {
        questionnaireAnswer: {
          userId: this.timeClockEntry.employee,
          TimeClockId: this.timeClockEntry.id,
          timestamp: new Date(),
          question1answer: this.form1.q1 === "yes" ? true : false,
          question1reason: this.form1.explain1,
          question2answer: this.form1.q2 === "yes" ? true : false,
          question2reason: this.form1.explain2,
          notes: this.form1.notes
        },
        jobMaterialsUsed,
      };

      await this.submitQuestionanire(payload);

      if (!this.status.error) {
        this.dialog = false;
        this.$emit("onSubmitted", this.timeClockEntry);
      }

      this.loading = false;
    },
  },
};
</script>